module.exports = __webpack_public_path__ + "static/pakmaya-ppd-sm-3bb72ad77e54a3e60ac53429855878d7.jpg";